import * as PIXI from "pixi.js";
import Tween from "tween.ts";
import Animation from "./Animation";


export default class MoveAnimation extends Animation {
  constructor(Container: PIXI.Container, properties: { [key: string]: number }, duration: number, _easing?: (k: number) => number) {
    super();
    const easing = _easing || Tween.Easing.Linear.None;
    new Tween.Tween(Container)
      .to(properties, duration)
      .easing(easing)
      .start();
  }
}